<div class="content" #contentElement>
	<router-outlet></router-outlet>
</div>
<div class="corner" [class.show]="adminMenuService.showTopLevelMenu()">
	<a routerLink="/">
		<img src="/assets/img/CumLaude_Logo_white.svg" />
	</a>
</div>
<app-hamburger-menu [class.show]="adminMenuService.showHamburgerMenu()"></app-hamburger-menu>
<app-admin-header></app-admin-header>
